import { Partner } from 'types/state';
import {
  createPartnerProfile,
  createPartnerProfileMock,
} from 'utils/partnerProfileUtils';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createPartner = (): Partner => ({
  id: 0,
  profile: createPartnerProfile(),
  code: '',
  createdOnDate: '',
  updatedOnDate: null,
});

export const createPartnerMock = (avatarURL?: string): Partner => ({
  id: createUniqueRuntimeNumber(),
  profile: createPartnerProfileMock(avatarURL),
  code: 'AA11',
  createdOnDate: new Date().toISOString(),
  updatedOnDate: null,
});
